import {
  API_PREFIX,
  type ActivityFeedResponse,
  type AuthTelegramResponse,
  type ClaimDailyRewardResponse,
  type HomeResponse,
  type PlayerProfileDTO,
  type PublicConfig,
  type PublicPlayerSummaryDTO,
  type RankingsResponse,
  type WalletSummary,
  type WsTicketResponse,
} from "@jaiho/shared";
import { api } from "./client";

export function authWithTelegram(initData: string): Promise<AuthTelegramResponse> {
  return api.post<AuthTelegramResponse>(`${API_PREFIX}/auth/telegram`, { initData });
}

export function getMe(): Promise<PlayerProfileDTO> {
  return api.get<PlayerProfileDTO>(`${API_PREFIX}/me`);
}

export function getWallet(): Promise<WalletSummary> {
  return api.get<WalletSummary>(`${API_PREFIX}/wallet`);
}

export function claimDailyReward(): Promise<ClaimDailyRewardResponse> {
  return api.post<ClaimDailyRewardResponse>(`${API_PREFIX}/wallet/daily-reward`);
}

export function getPublicConfig(): Promise<PublicConfig> {
  return api.get<PublicConfig>(`${API_PREFIX}/config`);
}

export function requestChatWsTicket(): Promise<WsTicketResponse> {
  return api.post<WsTicketResponse>(`${API_PREFIX}/chat/ws-ticket`);
}

export function getHome(): Promise<HomeResponse> {
  return api.get<HomeResponse>(`${API_PREFIX}/home`);
}

export function getXpRankings(limit = 50): Promise<RankingsResponse> {
  return api.get<RankingsResponse>(`${API_PREFIX}/rankings/xp?limit=${limit}`);
}

export function getRecentActivity(): Promise<ActivityFeedResponse> {
  return api.get<ActivityFeedResponse>(`${API_PREFIX}/activity`);
}

export function getPlayerSummary(userId: string): Promise<PublicPlayerSummaryDTO> {
  return api.get<PublicPlayerSummaryDTO>(`${API_PREFIX}/players/${encodeURIComponent(userId)}/summary`);
}

export function setIdentityVisibility(revealIdentity: boolean): Promise<PlayerProfileDTO> {
  return api.post<PlayerProfileDTO>(`${API_PREFIX}/me/identity-visibility`, { revealIdentity });
}
